import React from 'react';
import moment from 'moment';
import { Table, Column, Cell } from 'fixed-data-table';
import style from 'fixed-data-table/dist/fixed-data-table.css' // eslint-disable-line no-unused-vars
import s from './AuditLog.css';

const sortByColumn = (columnSortValue, columnDefaultSortDirection, activeSortValue, activeSortDescending, data, updateFunc, sortDataFunc) => {
  const sortDescending = columnSortValue === activeSortValue ? !activeSortDescending : columnDefaultSortDirection;
  return updateFunc(sortDataFunc(columnSortValue, sortDescending, data), columnSortValue, sortDescending);
}

const AuditLogTable = ({ data, sortValue, sortDescending, update, sortData }) =>
  <Table
    rowHeight={50}
    rowsCount={data.length}
    width={800}
    height={500}
    headerHeight={50}
    className={s.table}
  >
    <Column
      header={
        <Cell id="dateHeader" className={s.headerCell} onClick={() => sortByColumn('date', true, sortValue, sortDescending, data, update, sortData)}>
          Date
          {'date' === sortValue && sortDescending && ' ↓'}
          {'date' === sortValue && !sortDescending && ' ↑'}
        </Cell>
      }
      cell={({rowIndex, ...props}) => (
        <Cell {...props}>
          {moment(data[rowIndex].date).format('YYYY-MM-DD hh:mm a')}
        </Cell>
      )}
      width={100}
    />
    <Column
      header={
        <Cell id="modifiedByHeader" className={s.headerCell} onClick={() => sortByColumn('modifiedBy', false, sortValue, sortDescending, data, update, sortData)}>
          Modified by
          {'modifiedBy' === sortValue && sortDescending && ' ↓'}
          {'modifiedBy' === sortValue && !sortDescending && ' ↑'}
        </Cell>
      }
      cell={({rowIndex, ...props}) => (
        <Cell {...props}>
          {data[rowIndex].modifiedBy}
        </Cell>
      )}
      width={100}
    />
    <Column
      header={
        <Cell id="actionHeader" className={s.headerCell} onClick={() => sortByColumn('action', false, sortValue, sortDescending, data, update, sortData)}>
          Action
          {'action' === sortValue && sortDescending && ' ↓'}
          {'action' === sortValue && !sortDescending && ' ↑'}
        </Cell>
      }
      cell={({rowIndex, ...props}) => (
        <Cell {...props} className={s.dataCell}>
          <span className={s.actionCellContent}>
            {data[rowIndex].action}
            {data[rowIndex].targetName && <span className={s.auditTo}>{' to: ' + data[rowIndex].targetName}</span>}
          </span>
        </Cell>
      )}
      width={300}
    />
    <Column
      header={
        <Cell id="fieldHeader" className={s.headerCell} onClick={() => sortByColumn('field', false, sortValue, sortDescending, data, update, sortData)}>
          Changed field
          {'field' === sortValue && sortDescending && ' ↓'}
          {'field' === sortValue && !sortDescending && ' ↑'}
        </Cell>
      }
      cell={({rowIndex, ...props}) => (
        <Cell {...props}>
          {data[rowIndex].field}
        </Cell>
      )}
      width={100}
    />
    <Column
      header={<Cell id="beforeHeader">Value before</Cell>}
      cell={({rowIndex, ...props}) => (
        <Cell {...props}>
          {data[rowIndex].valueBefore}
        </Cell>
      )}
      width={100}
    />
    <Column
      header={<Cell id="afterHeader">Value after</Cell>}
      cell={({rowIndex, ...props}) => (
        <Cell {...props}>
          {data[rowIndex].valueAfter}
        </Cell>
      )}
      width={100}
    />
  </Table>

export default AuditLogTable;



// WEBPACK FOOTER //
// ./src/components/Pages/Account/AuditLog/AuditLogTable.js